import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints } from "../../../styles/breakpoints";
import { vars } from "../../../styles/theme.css";

const base = style({
  borderRadius: "0 0 0.3rem 0.3rem",
  backgroundColor: vars.colors.surfaceFixed,
  padding: "0.25rem",
  textAlign: "center",
  lineHeight: 1,
  color: vars.colors.primaryFixed,
  fontSize: vars.fontSizes.body.xs,

  "@media": {
    [`screen and (min-width: ${breakpoints[2]})`]: {
      padding: "0.4rem",
      fontSize: vars.fontSizes.body.s,
    },
  },
});

export const elementDetailsBarStyles = styleVariants({
  default: [base],
  live: [
    base,
    {
      background: vars.colors.liveMatchGradient,
      color: vars.colors.onPrimaryFixed,
      selectors: {
        '[dir="rtl"] &': {
          background: vars.colors.liveMatchGradientRtl,
        },
      },
    },
  ],
  finished: [
    base,
    { background: vars.colors.primaryFixed, color: vars.colors.onPrimaryFixed },
  ],
});
